import { observable, action, reaction, computed } from 'mobx';
import { makeObservable, toJS } from 'mobx';
import { MeasurementState } from '/@/app/views/FreeMeasurementsView/MeasurementState';
import { userState } from '/@/app/states/userState';
import { freeMeasurementsViewState } from '/@/app/views/FreeMeasurementsView/FreeMeasurementsViewState';


export class ParameterState {
    api=null;
    id = null;   // null for new parameter

    dictionary = null;
    panel_bound;

    // observables
    name = null;
    unit = null;

    records_id = null;
    unit_records_id = null;

    default_bottom_edge = null;
    default_top_edge = null;
    diagramData = null;
    measurements = null;
    sections = null;

    saveStatus;  // "saving", "saved", "error", "deleted"

    constructor(data,api) {
	this.api=api;
        if (this.id === null) {
            this.saveStatus = "new";
        } else {
            this.saveStatus = "saved";
        }

        makeObservable(this, {
            name: observable,
            unit: observable,
            panel_bound: observable,
            records_id: observable,
            unit_records_id: observable,
            default_bottom_edge: observable,
            default_top_edge: observable,
            diagramData: observable,
            //
            saveStatus: observable,
            setSaveStatus: action,
            //
            updateDiagramData: action,
            //
            init: action,
            save: action,
            saveSections: action,
            delete: action,
            // Granular actions; FIXME could be automatic
            _addMeasurement: action,
            _removeMeasurement: action,
            //
            hasData: computed
        });

        if (data !== undefined) {
            this.init(data);
        }

        this.updateDiagramData();
    }

    init(data) {
        // init existing parameter
        this.id = data.parameter.id;
        this.dictionary = data.parameter.dictionary;
        this.sections = data.sections;

        this.name = data.parameter.name;
        this.unit = data.parameter.unit;
        this.panel_bound = data.parameter.panel_bound;
        this.records_id = data.parameter.records_id;
        this.unit_records_id = data.parameter.unit_records_id;

        this.measurements = data.measurements.map(
            m => new MeasurementState(m, this, this.api)
        );

        this.default_bottom_edge = data.parameter.default_bottom_edge;
        this.default_top_edge = data.parameter.default_top_edge;

        // Update diagramData on items change
        for (let m of this.measurements) {
            this._setMeasurementRections(m);
        }
        reaction(() => this.default_bottom_edge, () => {
            this.updateDiagramData();
        });
        reaction(() => this.default_top_edge, () => {
            this.updateDiagramData();
        });

        reaction(() => this.measurements, () => {
            // FIXME not sure if it works now.
            this.updateDiagramData();
        });
    }

    _setMeasurementRections(m) {
        reaction(() => [
            m.value,
            m.default_top_edge,
            m.default_bottom_edge,
            m.made_at,
        ], () => {
            this.updateDiagramData();
        });
    }

    updateDiagramData() {
        if (this.measurements === null) {
            this.diagramData = null;
            return;
        }

        this.diagramData = this.measurements.filter(
            // remove stub items created for panels
            m => m.value !== null
        ).map(m => {
            return {
                "panel_id": m.panel_id,
                "made_at": m.made_at,
                "value": m.value,
                "warning_top_edge": (
                    m.warning_top_edge !== null
                        ? m.warning_top_edge
                        : this.default_top_edge
                ),
                "warning_bottom_edge": (
                    m.warning_bottom_edge !== null
                        ? m.warning_bottom_edge
                        : this.default_bottom_edge
                ),
                "id": m.id,
            }
        });
    }

    get hasData() {
        return this.measurements.filter(m => m.value !== null).length > 0;
    }

    setSaveStatus(status) {
        this.saveStatus = status;
    }


    save(data) {
        let url;
        let method;
        if (this.id === null) {
            url = `cabinet/free/${userState.id}/parameters/`;
            method = "POST";
        } else {
            url = `cabinet/free/${userState.id}/parameters/${this.id}/`;
            method = "PATCH";
        }

        const isNew = this.id === null;
        this.saveStatus = "saving";

        return this.api.request(url, data, { method: method, })
	.then((data) => {
            this.setSaveStatus("saved");
            this.init(data);
            if (isNew) {
                freeMeasurementsViewState._addNewParameter(this);
            }
        }).catch(e => {
            this.setSaveStatus("error");
        });
    }

    saveSections(sections) {
        this.saveStatus = "saving";

        return this.api.request(
            `cabinet/free/${userState.id}/parameters/${this.id}/`,
	    {sections: sections},
            {
                method: "PATCH",
            }
        ).then((data) => {
            this.setSaveStatus("saved");
            this.init(data);
            freeMeasurementsViewState._updateSections(this);
        }).catch(e => {
            this.setSaveStatus("error");
        });
    }

    delete() {
        if (this.id === null) {
            return;
        }

        this.saveStatus = "saving";

        return this.api.request(
            `cabinet/free/${userState.id}/parameters/${this.id}/`,
	    {},
            { method: "DELETE" }
        ).then(() => {
            this.setSaveStatus("deleted");
            freeMeasurementsViewState._removeParameter(this);
        }).catch(e => {
            this.setSaveStatus("error");
        });
    }


    _addMeasurement(measurement) {
        this.measurements.push(measurement);
        this.updateDiagramData();  // FIXME could be automatic
        this._setMeasurementRections(measurement);
    }

    _removeMeasurement(measurement) {
        this.measurements = this.measurements.filter(m => m.id !== measurement.id);
        this.updateDiagramData();  // FIXME could be automatic
    }
}
